module.exports = __webpack_public_path__ + "img/top-bg-hen.2de0707f.png";